export default __webpack_public_path__ + "static/100--stacked-column-fa4756602191f5003de917a3236afbe0.png";